import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_EM_56 } from "@/lib/programData";

export default function ErgMarrakech56Page() {
  return <ProgramTemplate program={PROGRAM_EM_56} variant="em" showJourneyChronology />;
}
